import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';

import { AddressViewModel } from '@app/api/models';

import { notBlank } from '../../validators/not-blank.validator';
import { SubformBaseComponent } from '../subform-base/subform-base.component';

@Component({
  selector: 'app-easy-address-subform',
  templateUrl: './easy-address-subform.component.html',
  styleUrls: ['./easy-address-subform.component.scss'],
})
export class EasyAddressSubformComponent
  extends SubformBaseComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  DICT_PATH = 'SHARED.ADDRESS';

  @Input() title!: string;
  @Input() showCopyBasicDataButton = false;
  @Input() basicDataAddress?: AddressViewModel;
  @Output() copyBasicData = new EventEmitter();

  placeListener: any;

  static buildAddressForm(fb: UntypedFormBuilder): UntypedFormGroup {
    return fb.group({
      zipCode: [
        null,
        [
          Validators.required,
          notBlank,
          Validators.minLength(4),
          Validators.maxLength(4),
        ],
      ],
      city: [null, [Validators.required, notBlank]],
      streetName: [null, [Validators.required, notBlank]],
      streetType: [null, [Validators.required, notBlank]],
      number: [null, [Validators.required, notBlank]],
      building: [],
      stairs: [],
      floor: [],
      door: [],
    });
  }

  addressSearch = this.fb.control(null);

  override ngOnInit(): void {
    super.ngOnInit();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.initializeGooglePlaces(this.group);
    });
  }

  initializeGooglePlaces(form: UntypedFormGroup) {
    const input = document.getElementById(
      'googlePlacesAutocomplete'
    ) as HTMLInputElement;

    const autocomplete = new google.maps.places.Autocomplete(input);
    autocomplete.setFields(['address_components']);
    autocomplete.setComponentRestrictions({ country: ['hu'] });
    this.placeListener = autocomplete.addListener('place_changed', function () {
      const place = autocomplete.getPlace();
      const components = place.address_components;

      if (components) {
        form.markAsDirty();
        for (let component of components) {
          const type = component.types[0];
          const longName = component.long_name;

          switch (type) {
            case 'route':
              const lastSpace = longName.lastIndexOf(' ');
              const streetName = longName.substring(0, lastSpace);
              const streetType = longName.substring(lastSpace);
              form.get('streetName')?.setValue(streetName);
              form.get('streetType')?.setValue(streetType);
              break;
            case 'locality':
              form.get('city')?.setValue(longName);
              break;
            case 'postal_code':
              form.get('zipCode')?.setValue(longName);
              break;
            case 'street_number':
              form.get('number')?.setValue(longName);
              break;
          }
        }
      }
    });
  }

  useBasicDataAddress(event: MatCheckboxChange) {
    if (this.basicDataAddress && event.checked) {
      if (this.basicDataAddress.region) {
        const { region: _, ...newAddress } = this.basicDataAddress;
        this.group.setValue(newAddress);
      } else {
        this.group.setValue(this.basicDataAddress);
      }
      this.group.disable();
      this.addressSearch.disable();
    } else {
      this.group.enable();
      this.addressSearch.enable();
      this.group.reset();
    }
  }

  onGoogleKeydown(event: KeyboardEvent) {
    if (event.code === 'Enter') {
      event.preventDefault();
    }
  }

  onSuggestionSelected(address: AddressViewModel) {
    if (address) this.group.setValue(address);
  }

  ngOnDestroy(): void {
    google.maps.event.removeListener(this.placeListener);
  }
}
